import { render, staticRenderFns } from "./ex-list.vue?vue&type=template&id=f6ab76a2&scoped=true&"
import script from "./ex-list.vue?vue&type=script&lang=js&"
export * from "./ex-list.vue?vue&type=script&lang=js&"
import style0 from "./ex-list.vue?vue&type=style&index=0&id=f6ab76a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ab76a2",
  null
  
)

export default component.exports